import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";

import { App, AppErrorBoundary } from "./App";
import { loadRuntimeConfig, WatchpointApi } from "./api";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing");

try {
  const config = await loadRuntimeConfig();
  const api = new WatchpointApi(config);

  createRoot(root).render(
    <StrictMode>
      <AppErrorBoundary>
        <Suspense fallback={<p role="status">Loading Watchpoint…</p>}>
          <App api={api} />
        </Suspense>
      </AppErrorBoundary>
    </StrictMode>,
  );
} catch (error) {
  createRoot(root).render(
    <div className="state-card state-card--error" role="alert">
      <div>
        <strong>Watchpoint is not configured</strong>
        <p>
          {error instanceof Error ? error.message : "Configuration failed."}
        </p>
      </div>
    </div>,
  );
}
